import Button from 'components/Button/Button';
import Input from 'components/Input/Text/Input';

import Note from './components/Note/Note';

import './DrawerNotes.scoped.scss';

const DrawerNotes: React.FC = () => {
  return (
    <div className="drawer-notes">
      <h4>
        Add a note <span>3</span>
      </h4>

      <div className="input-container">
        <Input type="text" onChange={() => undefined} placeholder="Add a note here" />
      </div>

      <div className="buttons-container">
        <Button
          onClick={() => undefined}
          outlined
          style={{
            width: '110px',
            height: '33px',
            backgroundColor: 'transparent',
            color: '#ffff',
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => undefined}
          icon
          style={{
            width: '110px',
            height: '33px',
            background: '#5CD79E',
            borderRadius: '23px',
            color: '#ffff',
          }}
        >
          Submit
        </Button>
      </div>

      <div className="line" />

      <Note />
      <Note />
      <Note />
      <Note />
      <Note />
    </div>
  );
};

export default DrawerNotes;
